"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _field = _interopRequireDefault(require("./field"));

var ButtonField =
/*#__PURE__*/
function (_Field) {
  (0, _inherits2.default)(ButtonField, _Field);

  function ButtonField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ButtonField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'ButtonField');
    return _this;
  }

  (0, _createClass2.default)(ButtonField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(ButtonField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'type',
            component: 'SelectField',
            label: 'Type',
            options: [{
              value: 'submit',
              label: 'Submit'
            }],
            docLevel: 'basic'
          }, {
            // TODO: create IconListField (with preview) and use it here
            name: 'icon',
            component: 'TextField',
            label: 'Icon',
            docLevel: 'basic'
          }, {
            name: 'variant',
            component: 'TextField',
            // Hidden as it may not be portable to have a variant type and this may be better to
            // configure at the theme layer
            hidden: true
          }]
        }
      });

      this._setDefaults(props, {
        block: false,
        out: false
      });
    }
  }, {
    key: "emitClick",
    value: function emitClick() {
      this.emitChange('click');

      if (this.get('type') === 'submit') {
        // Disable to prevent the user from clicking the button again before the action has completed
        this.set({
          disabled: true
        });
      }
    }
  }]);
  return ButtonField;
}(_field.default);

exports.default = ButtonField;